import store from "../core/services/store/index";

export default (permissions) => {

    const userPermissions = store.getters['currentUser'].permissions;
    let canEnter = false;

    if (!userPermissions || !permissions){
        return canEnter
    }


    if (!Array.isArray(permissions)){
        canEnter = userPermissions.includes(permissions);
    } else {
        permissions.forEach((permission) => {
            canEnter = userPermissions.includes(permission)
        });
    }

    return canEnter


}